<template>
  <header :class="{'scrolled': scrolledNav}" class="header">
    <nav class="nav" aria-label="主選單">
      <div class="branding">
        <img src="@/assets/logo.png" alt="AMIS Logo" class="logo" width="230" height="102">
      </div>
      
      <ul
        v-show="!mobile"
        class="navigation"
      >
        <li v-for="item in menuItems" :key="item.name">
          <router-link
            class="nav-link"
            :to="{ name: item.route}"
            :class="{ 'active': $route.name === item.route }"
          >
            {{ item.name }}
          </router-link>
        </li>
      </ul>
      
      <button 
        v-show="mobile"
        class="mobile-menu-btn"
        @click="toggleMobileNav"
        :class="{ 'active': mobileNav }"
        :aria-expanded="mobileNav ? 'true' : 'false'"
        aria-controls="mobile-menu"
        aria-label="切換選單"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
      
      <Transition name="mobile-nav">
        <div
          v-show="mobileNav"
          id="mobile-menu"
          class="mobile-overlay"
          @click="toggleMobileNav"
        >
          <ul
            class="mobile-navigation"
            @click.stop
          >
            <li v-for="item in menuItems" :key="item.name">
              <router-link
                class="mobile-nav-link"
                :to="{ name: item.route}"
                :class="{ 'active': $route.name === item.route }"
                @click="toggleMobileNav"
              >
                {{ item.name }}
              </router-link>
            </li>
          </ul>
        </div>
      </Transition>
    </nav> 
  </header>
</template>

<script>
export default {
    name: 'MenuBar',
    data() {
        return {
            scrolledNav: false,
            mobile: false,
            mobileNav: false,
            windowWidth: null,
            menuItems: [
                { name: '首頁', route: 'Home' },
                { name: '關於我們', route: 'About' },
                { name: '我們的服務', route: 'Service' },
                { name: '新聞報導', route: 'News' },
                { name: '聯繫我們', route: 'Contact' }
            ]
        }
    },
    created() {
      window.addEventListener("resize", this.checkScreen)
      window.addEventListener("scroll", this.updateScroll)
      this.checkScreen()
    },
    beforeUnmount() {
      window.removeEventListener("resize", this.checkScreen)
      window.removeEventListener("scroll", this.updateScroll)
    },
    methods: {
        toggleMobileNav() {
            this.mobileNav = !this.mobileNav
            // Prevent body scroll when mobile menu is open
            document.body.style.overflow = this.mobileNav ? 'hidden' : ''
        },

        updateScroll() {
            const scrollPosition = window.scrollY
            this.scrolledNav = scrollPosition > 50
        },
        
        checkScreen() {
            this.windowWidth = window.innerWidth
            if (this.windowWidth < 768) {
                this.mobile = true
                return
            }
            this.mobile = false
            this.mobileNav = false
            document.body.style.overflow = ''
            return
        }
    }
}
</script>

<style lang="scss" scoped>
.header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    transition: var(--transition-normal);
    border-bottom: 1px solid transparent;
    
    &.scrolled {
        background: rgba(255, 255, 255, 0.98);
        border-bottom: 1px solid var(--primary-light);
        box-shadow: var(--shadow-md);
    }
}

.nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--spacing-md) var(--spacing-lg);
    max-width: 1200px;
    margin: 0 auto;
    
    @media (max-width: 768px) {
        padding: var(--spacing-sm) var(--spacing-md);
    }
}

.branding {
    display: flex;
    align-items: center;
    
    .logo {
        width: 200px;
        height: auto;
        transition: var(--transition-normal);
        
        @media (max-width: 768px) {
            width: 150px;
        }
    }
}

.navigation {
    display: flex;
    align-items: center;
    gap: var(--spacing-xl);
    list-style: none;
    margin: 0;
    padding: 0;
}

.nav-link {
    color: var(--text-primary);
    text-decoration: none;
    font-weight: 500;
    font-size: var(--font-size-sm);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: var(--spacing-sm) var(--spacing-md);
    border-radius: var(--radius-md);
    transition: var(--transition-fast);
    position: relative;
    
    &:hover {
        color: var(--primary-text);
        background: rgba(137, 177, 185, 0.1);
    }
    
    &.active {
        color: var(--primary-text);
        background: rgba(137, 177, 185, 0.15);
    }
    
}

.mobile-menu-btn {
    display: none;
    flex-direction: column;
    justify-content: space-around;
    width: 44px;
    height: 44px;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 10px 7px;
    z-index: 1001;
    touch-action: manipulation;
    
    span {
        width: 100%;
        height: 3px;
        background: var(--text-primary);
        border-radius: 2px;
        transition: transform 0.2s ease, opacity 0.2s ease;
        transform-origin: center;
    }
    
    &.active {
        span:nth-child(1) {
            transform: rotate(45deg) translate(6px, 6px);
        }
        
        span:nth-child(2) {
            opacity: 0;
        }
        
        span:nth-child(3) {
            transform: rotate(-45deg) translate(6px, -6px);
        }
    }
    
    @media (max-width: 768px) {
        display: flex;
    }
}

.mobile-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(5px);
    z-index: 999;
}

.mobile-navigation {
    position: fixed;
    top: 0;
    right: 0;
    width: 280px;
    height: 100vh;
    background: white;
    padding: var(--spacing-2xl) var(--spacing-lg);
    list-style: none;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-lg);
    box-shadow: var(--shadow-xl);
    
    .mobile-nav-link {
        color: var(--text-primary);
        text-decoration: none;
        font-weight: 500;
        font-size: var(--font-size-lg);
        padding: var(--spacing-md);
        border-radius: var(--radius-md);
        transition: var(--transition-fast);
        
        &:hover,
        &.active {
            color: var(--primary-text);
            background: rgba(137, 177, 185, 0.1);
        }
    }
}

// Mobile Navigation Transitions
.mobile-nav-enter-active,
.mobile-nav-leave-active {
    transition: var(--transition-normal);
}

.mobile-nav-enter-from {
    opacity: 0;
    transform: translateX(100%);
}

.mobile-nav-leave-to {
    opacity: 0;
    transform: translateX(100%);
}

@media (max-width: 768px) {
    .navigation {
        display: none;
    }
}
</style>
